/* The Showroom UK theme. Generated by showroom-redesign/tools/build_theme.py — edit the site or src/boot.js, then rebuild. */
(() => {
'use strict';
const SR = window.SR || {};
const A = p => { const n = String(p).split('/').pop(); return (window.SR_ASSETS || {})[n] || p; };
const gbp = n => '£' + n.toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2});
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const $ = (s, r=document) => r.querySelector(s);

/* ---------- hero scenes ---------- */
const SCENES = [
  {key:'Marvel', img:A('marvel-mint.webp'), alt:'Topps Marvel Mint box', glow:'rgba(127,143,242,.2)', halo:'rgba(214,170,74,.55)', gx:'72%',
   eyebrow:'Topps × Marvel · Mint', h:'Marvel Mint <em>has landed</em>',
   lede:'Hulk, Jean Grey and Spider-Man on the box, with one encased card and one numbered parallel guaranteed in every box.',
   spec:['1 encased card per box','1 numbered parallel','Topps'], price:null, cta:'Shop Topps', href:SR.links.topps, ghost:'Mint'},
  {key:'Pokémon', img:A('pokemon-30th-etb.webp'), alt:'Pokémon 30th Celebration Elite Trainer Box', glow:'rgba(63,208,220,.16)', halo:'rgba(244,196,64,.6)', gx:'64%',
   eyebrow:'Pokémon TCG · 30th Celebration', h:'Thirty years. <em>One box.</em>',
   lede:'The 30th Celebration Elite Trainer Box leads the shelf, next to sealed booster boxes, bundles and ETBs from Scarlet & Violet.',
   spec:['Elite Trainer Box','30th Celebration','Factory sealed'], price:null, cta:'Shop Pokémon', href:SR.links.pokemon, ghost:'30th'},
  {key:'The Vault', img:A('umbreon-vmax-psa10.webp'), alt:'Umbreon VMAX 215/203 graded PSA 10', glow:'rgba(155,114,238,.2)', halo:'rgba(63,208,220,.6)', gx:'70%',
   eyebrow:'The Vault · PSA 10', h:'Grails, graded <em>and slabbed</em>',
   lede:'Moonbreon: the Umbreon VMAX alt art from Evolving Skies, graded PSA 10 Gem Mint. Our slabs sell fast, so the Vault shows what has been through the door.',
   spec:['PSA 10 Gem Mt','#215/203','Cert 74733658'], price:null, cta:'Open the Vault', href:SR.links.vault, ghost:'PSA 10'},
  {key:'Sell to us', img:A('op01-romance-dawn.webp'), alt:'ONE PIECE Romance Dawn OP01 booster box', glow:'rgba(213,216,226,.13)', halo:'rgba(70,110,240,.6)', gx:'66%',
   eyebrow:'We buy stock', h:'Sitting on <em>sealed boxes?</em>',
   lede:'Tell us what you have, from one booster box to a full collection. We reply by email with an offer and arrange the rest.',
   spec:['Sealed product','Graded slabs','Collections'], price:null, cta:'Get an offer', href:SR.links.sell, ghost:'We buy'},
];
if (Array.isArray(window.SR_HERO) && SR_HERO.length) SCENES.splice(0, SCENES.length, ...SR_HERO);

function heroHTML(){
  return `
  <section class="hero" id="hero" aria-label="Featured">
    <div class="stage" id="stage">
      <div class="ghost" id="ghost" aria-hidden="true">${SCENES[0].ghost}</div>
      <div class="wrap stage-inner">
        <div class="copy">
          ${SCENES.map((s,i)=>`
          <div class="scene${i===0?' on':''}" data-i="${i}" ${i?'aria-hidden="true"':''}>
            <div class="eyebrow">${s.eyebrow}</div>
            <h1>${s.h}</h1>
            <p class="lede">${s.lede}</p>
            <div class="spec">${s.spec.map(x=>`<span class="chip">${x}</span>`).join('')}</div>
            <div class="row">
              <a class="btn btn-primary" href="${s.href}" ${i?'tabindex="-1"':''}>${s.cta} <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>
              ${s.price!=null?`<div class="price-lg"><small>${s.pre}</small>${gbp(s.price)}</div>`:''}
            </div>
          </div>`).join('')}
        </div>
        <div class="showcase" id="showcase">
          <div class="aura"></div>
          <div class="ring"></div>
          <div class="floor"></div>
          <canvas class="motes" id="motes"></canvas>
          ${SCENES.map((sc,i)=>`
          <a class="prod${i===0?' on':''}" data-i="${i}" href="${sc.href}" tabindex="-1" aria-label="${esc(sc.cta)}"><div class="bob">
            <img src="${sc.img}" alt="${esc(sc.alt)}" ${i?'loading="lazy"':''}>
            <span class="sheen" style="-webkit-mask-image:url(${sc.img});mask-image:url(${sc.img})"></span>
          </div></a>`).join('')}
        </div>
      </div>
      <div class="rail" id="rail">${SCENES.map((s,i)=>`<button data-i="${i}" class="${i===0?'on':''}" aria-label="Show ${esc(s.key)}"><i></i><span>${esc(s.key)}</span></button>`).join('')}</div>
      <div class="scroll-hint" id="hint">Scroll</div>
    </div>
  </section>`;
}

function bindHero(){
  const hero = $('#hero'), stage = $('#stage'), show = $('#showcase');
  const scenes = [...hero.querySelectorAll('.scene')], prods = [...hero.querySelectorAll('.prod')];
  const rails = [...hero.querySelectorAll('.rail button')], ghost = $('#ghost'), hint = $('#hint');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let cur = 0, raf = 0, lastY = scrollY, speed = 0;
  const set = i => {
    if (i === cur) return;
    scenes.forEach((s,k)=>{s.classList.toggle('on',k===i); s.toggleAttribute('aria-hidden',k!==i); s.querySelector('a').tabIndex = k===i?0:-1;});
    prods.forEach((c,k)=>{c.classList.toggle('on',k===i); c.classList.toggle('out',k<i);});
    rails.forEach((r,k)=>r.classList.toggle('on',k===i));
    stage.style.setProperty('--glow',SCENES[i].glow); stage.style.setProperty('--gx',SCENES[i].gx);
    show.style.setProperty('--halo',SCENES[i].halo);
    ghost.style.opacity = 0; setTimeout(()=>{ghost.textContent = SCENES[i].ghost; ghost.style.opacity = 1;},250);
    cur = i;
  };
  const tick = () => {
    raf = 0;
    const r = hero.getBoundingClientRect(), span = hero.offsetHeight - stage.offsetHeight;
    const p = Math.min(1, Math.max(0, -r.top / span));
    const f = p * SCENES.length, i = Math.min(SCENES.length-1, Math.floor(f)), t = f - i;
    set(i);
    rails.forEach((b,k)=>b.querySelector('i').style.setProperty('--fill', k<i?1:k===i?t:0));
    hint.style.opacity = p > .02 ? 0 : 1;
    speed = Math.min(40, Math.abs(scrollY - lastY)); lastY = scrollY;
    if (!reduce){
      const c = prods[i];
      c.style.setProperty('--ry', (-16 + t*26).toFixed(2)+'deg');
      c.style.setProperty('--rx', (6 - t*8).toFixed(2)+'deg');
      c.querySelector('.sheen').style.setProperty('--sp', (120 - t*140).toFixed(1)+'%');
    }
  };
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(tick); };
  rails.forEach(b=>b.addEventListener('click',()=>{
    const span = hero.offsetHeight - stage.offsetHeight;
    const top = hero.getBoundingClientRect().top + scrollY + span * ((+b.dataset.i + .35) / SCENES.length);
    scrollTo({top, behavior: reduce?'auto':'smooth'});
  }));
  addEventListener('scroll', onScroll, {passive:true}); addEventListener('resize', onScroll);
  tick();
  const stopMotes = motes($('#motes'), () => speed, reduce);
  return () => { removeEventListener('scroll', onScroll); removeEventListener('resize', onScroll); stopMotes(); };
}

/* Drifting sparkles around the product. Scrolling stirs them up a little. */
function motes(cv, getSpeed, reduce){
  const ctx = cv.getContext('2d'); if (!ctx) return () => {};
  const tints = ['63,208,220','127,143,242','155,114,238','213,216,226'];
  let W = 0, H = 0, dpr = 1, raf = 0, alive = true, last = performance.now(), stir = 0;
  const size = () => { dpr = Math.min(devicePixelRatio || 1, 2); W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr,0,0,dpr,0,0); };
  size(); addEventListener('resize', size);
  const spawn = (y) => ({x: Math.random() * W, y: y ?? Math.random() * H, r: .5 + Math.random() * 1.8, v: 6 + Math.random() * 16, ph: Math.random() * 6.28, sw: 8 + Math.random() * 22, c: tints[Math.random() * tints.length | 0]});
  const ps = Array.from({length: W < 500 ? 38 : 64}, () => spawn());
  const draw = now => {
    if (!alive) return;
    raf = requestAnimationFrame(draw);
    const dt = Math.min(.05, (now - last) / 1000); last = now;
    if (cv.getBoundingClientRect().bottom < 0) return;
    stir += (getSpeed() / 8 - stir) * .06;
    ctx.clearRect(0, 0, W, H);
    ctx.globalCompositeOperation = 'lighter';
    for (const p of ps){
      if (!reduce){ p.y -= (p.v + stir * 30) * dt; p.ph += dt * 1.4; }
      if (p.y < -10) Object.assign(p, spawn(H + 10));
      const x = p.x + Math.sin(p.ph) * p.sw * .3;
      const tw = .35 + .65 * Math.abs(Math.sin(p.ph * 1.7));
      const fade = Math.min(1, p.y / (H * .25), (H - p.y) / (H * .2) + .2);
      const a = Math.max(0, tw * fade);
      const g = ctx.createRadialGradient(x, p.y, 0, x, p.y, p.r * 5);
      g.addColorStop(0, `rgba(${p.c},${.9 * a})`); g.addColorStop(.25, `rgba(${p.c},${.35 * a})`); g.addColorStop(1, `rgba(${p.c},0)`);
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, p.y, p.r * 5, 0, 6.283); ctx.fill();
      if (p.r > 1.9 && a > .7){ // the odd bigger one gets a four-point glint
        ctx.strokeStyle = `rgba(255,255,255,${.5 * a})`; ctx.lineWidth = .6;
        ctx.beginPath(); ctx.moveTo(x - p.r * 4, p.y); ctx.lineTo(x + p.r * 4, p.y); ctx.moveTo(x, p.y - p.r * 4); ctx.lineTo(x, p.y + p.r * 4); ctx.stroke();
      }
    }
  };
  raf = requestAnimationFrame(draw);
  return () => { alive = false; cancelAnimationFrame(raf); removeEventListener('resize', size); };
}

/* ---------- live on whatnot ---------- */
const WHATNOT = SR.whatnot || 'https://www.whatnot.com/en-GB/user/theshowroomuk';
const DISCORD = SR.discord || 'https://discord.gg/9eefvwtZaz';
const IG = SR.instagram || 'https://www.instagram.com/theshowroom_uk/';
const WN_ICON = '<svg viewBox="0 0 115 115" aria-hidden="true"><path fill="#ffe406" d="M114.97,57.48c0,44.45-13.04,57.48-57.48,57.48S0,101.93,0,57.48,13.04,0,57.49,0s57.48,13.04,57.48,57.48"/><path fill="#282527" d="M44.79,84.07c5.85,0,9.33-6.07,7-15.53l-.66-2.68c-.35-1.5,1.06-2.07,1.85-.75l3.78,6.12c6.47,10.47,9.11,12.85,13.95,12.85,4.58,0,8.36-3.08,15.31-13.95l3.34-5.24c4.88-7.66,6.86-11.57,6.86-16.67,0-6.42-4.71-11.66-11.88-11.66-5.5,0-8.93,2.42-11.97,8.49l-.79,1.58c-.53,1.1-1.67,1.01-2.07,0l-.57-1.54c-2.16-5.76-5.9-8.54-11.48-8.54s-9.15,2.77-11.35,8.54l-.57,1.5c-.4,1.06-1.45,1.14-2.07,0l-.79-1.54c-3.08-6.03-6.6-8.49-12.1-8.49-7.17,0-11.83,5.24-11.83,11.66,0,5.1,1.85,9.02,6.82,16.54l3.26,4.93c7.83,11.88,11.44,14.39,15.97,14.39Z"/></svg>';
// Whatnot profile numbers as of 19 Oct 2026
const WN_STATS = Object.assign({rating:'4.9', reviews:'2,347', sold:'34.3k', followers:'8.8k', ship:'1 day'}, SR.stats || {});
const REELS = {
  ahsoka:{id:'DektjQiIwUH', hit:'1/1', title:'Triple Auto Ahsoka', set:'Topps Star Wars Chrome'},
  maul25:{id:'Dekt8g0IMvp', hit:'/25', title:'Darth Maul Chrome', set:'Topps Star Wars Chrome'},
  thrawn:{id:'DedCoJ5Iy7A', hit:'SSP', title:'Kyber Light Thrawn', set:'Topps Star Wars Chrome'},
  era:{id:'DeajYLVqGXT', hit:'Era', title:'Episode I Darth Maul', set:'Topps Star Wars Chrome'},
  cases:{id:'Denthv0I-6o', hit:'Case', title:'Case break day', set:'Star Wars Chrome cases'},
};
const DC_ICON = '<svg class="dc-logo" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"/></svg>';
const arrowSm = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
const STOPS = [
  {label:'Live', kind:'still', tone:'y', w:380, html:`${WN_ICON.replace('<svg','<svg class="wmark"')}
     <div><div class="k-eye">theshowroomuk on Whatnot</div><h3 style="margin-top:12px">We break live</h3></div>
     <p>One Piece, Pokémon, Star Wars Chrome and more, opened on stream. Grab a spot and watch your cards get pulled.</p>`},
  {label:'1/1', kind:'clip', reel:'ahsoka'},
  {label:'Hits', kind:'still', tone:'k', w:380, html:`<div><div class="k-eye hb-live"><i></i>Last 40 days · Instagram</div><h3 style="margin-top:12px">Our <em>hit board</em></h3></div>
     <ol class="hitlist" id="hitlist"><li class="hb-empty">Loading the latest hits…</li></ol>
     <div class="hb-foot" id="hbFoot">From @theshowroom_uk posts</div>`},
  {label:'/25', kind:'clip', reel:'maul25'},
  {label:'Trusted', kind:'still', tone:'y', w:380, html:`<div><div class="k-eye">Whatnot seller rating</div><div class="big" style="margin-top:10px">${WN_STATS.rating}★</div></div>
     <div class="grid2"><div><b>${WN_STATS.reviews}</b><span>reviews</span></div><div><b>${WN_STATS.sold}</b><span>items sold</span></div><div><b>${WN_STATS.followers}</b><span>followers</span></div><div><b>${WN_STATS.ship}</b><span>average ship time</span></div></div>`},
  {label:'SSP', kind:'clip', reel:'thrawn'},
  {label:'Discord', kind:'still', tone:'k dc', w:380, html:`<div>${DC_ICON}<div class="k-eye" style="margin-top:18px">Community</div><h3 style="margin-top:12px">Join the <em>Discord</em></h3></div>
     <p>Hang out with the community between streams, talk breaks and see the hits.</p>
     <div style="display:grid;gap:12px"><div class="inv">discord.gg/9eefvwtZaz</div><a class="go" href="${DISCORD}" target="_blank" rel="noopener">Join the Discord ${arrowSm}</a></div>`},
  {label:'Era', kind:'clip', reel:'era'},
  {label:'£25', kind:'still', tone:'y', w:380, html:`<div><div class="k-eye">New to Whatnot?</div><div class="big" style="margin-top:10px">£25</div></div>
     <p style="font-size:18px;font-weight:600">Free credit when you sign up to Whatnot through our link.</p>
     <a class="go" href="${WHATNOT}" target="_blank" rel="noopener">Claim it on Whatnot ${arrowSm}</a>`},
  {label:'Cases', kind:'clip', reel:'cases'},
  {label:'Follow', kind:'still', tone:'k', w:380, html:`${WN_ICON.replace('<svg','<svg class="wmark"')}
     <div><div class="k-eye">${WN_STATS.followers} followers and counting</div><h3 style="margin-top:12px">See you <em>on stream</em></h3></div>
     <a class="go" href="${WHATNOT}" target="_blank" rel="noopener">Follow on Whatnot ${arrowSm}</a>`},
];

function liveHTML(){
  return `
  <section class="wn" id="whatnot" aria-labelledby="liveTitle">
    <div class="wrap wn-top">
      <div>
        <div class="wn-brand">${WN_ICON}<div><b>theshowroomuk</b><span>Live on Whatnot <span class="wn-onair"><i></i>Live</span></span></div></div>
        <h2 id="liveTitle">Rip it <em>live</em><br>with us</h2>
      </div>
      <div class="wn-stats">
        <div><b>${WN_STATS.rating}★</b><span>${WN_STATS.reviews} reviews</span></div>
        <div><b>${WN_STATS.sold}</b><span>items sold</span></div>
        <div><b>${WN_STATS.followers}</b><span>followers</span></div>
        <div><b>${WN_STATS.ship}</b><span>avg ship</span></div>
      </div>
    </div>
    <div class="journey" id="journey"><div class="world" id="world">
      ${STOPS.map((st,i)=>{
        if (st.kind==='clip'){ const r = REELS[st.reel]; return `
        <div class="stop" data-i="${i}" style="--w:240px;--h:426px"><a class="jcard clip" href="https://www.instagram.com/reel/${r.id}/" target="_blank" rel="noopener" data-id="${r.id}" aria-label="Watch the ${esc(r.title)} pull on Instagram">
          <img src="${A(r.id+'.jpg')}" alt="" loading="lazy" draggable="false">
          <video muted loop playsinline preload="none" poster="${A(r.id+'.jpg')}"></video>
          <span class="tag">${esc(r.hit)}</span><span class="src">Instagram</span>
          <span class="play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 4.5v15l13-7.5z"/></svg></span>
          <div class="cap"><b>${esc(r.title)}</b><span>${esc(r.set)}</span></div>
        </a></div>`; }
        return `<div class="stop" data-i="${i}" style="--w:${st.w}px;--h:426px"><div class="jcard still ${st.tone}">${st.html}</div></div>`;
      }).join('')}
    </div></div>
    <div class="wrap tl">
      <button class="tl-btn" id="tlPrev" aria-label="Previous stop"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 6l-6 6 6 6"/></svg></button>
      <div class="track" id="track">
        <div class="rail2"></div><div class="fill2" id="fill2"></div>
        ${STOPS.map((st,i)=>`<button class="dot" data-i="${i}" style="left:${(i/(STOPS.length-1)*100).toFixed(3)}%" aria-label="Go to ${esc(st.label)}"><span>${esc(st.label)}</span></button>`).join('')}
        <div class="knob" id="knob" role="slider" tabindex="0" aria-label="Journey position" aria-valuemin="1" aria-valuemax="${STOPS.length}" aria-valuenow="1"><span class="bubble" id="bubble">${STOPS[0].label}</span></div>
      </div>
      <button class="tl-btn playing" id="tlPlay" aria-label="Pause the journey"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg></button>
    </div>
    <div class="wrap wn-foot">
      <a class="btn btn-y" href="${WHATNOT}" target="_blank" rel="noopener">Follow us on Whatnot ${arrowSm}</a>
      <a class="btn btn-o" href="${SR.links.live}">How our breaks work</a>
      <a class="btn btn-o btn-dc" href="${DISCORD}" target="_blank" rel="noopener">${DC_ICON}Join the Discord</a>
      <a class="btn btn-o" href="${IG}" target="_blank" rel="noopener">More pulls on Instagram</a>
    </div>
  </section>`;
}

/* Hit board: The hit board feed is built from @theshowroom_uk posts by tools/refresh_hits.py.
   Only hits posted in the last 40 days are shown, so the board empties itself as hits age out. */
// Best cards first. Keep in step with rarity() in tools/refresh_hits.py.
function rarity(hit){
  const h = String(hit).trim().toLowerCase(), n = (h.match(/^\/(\d+)$/) || [])[1];
  if (h === '1/1') return 1;
  if (h === 'sketch') return 2;
  if (n) return +n <= 5 ? 3 : +n <= 10 ? 4 : 6 + n / 1000;
  if (h === 'era') return 5;
  if (['ssp', 'case', 'case hit'].includes(h)) return 8;
  if (h === 'auto') return 9;
  return 10;
}
function loadHits(){
  const list = $('#hitlist'), foot = $('#hbFoot'); if (!list) return;
  const DAY = 864e5, now = Date.now();
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const ago = d => { const [y, m, dd] = d.split('-').map(Number); const n = Math.round((today - new Date(y, m - 1, dd)) / DAY); return n <= 0 ? 'Today' : n === 1 ? 'Yesterday' : n + 'd ago'; };
  (window.SR_HITS ? Promise.resolve(window.SR_HITS) : Promise.reject()).then(feed => {
    const win = feed.window_days || 40, cutoff = now - win * DAY;
    const hits = feed.hits.map(h => ({...h, posts: h.posts.filter(p => new Date(p.date + 'T23:59:59Z') >= cutoff)}))
      .filter(h => h.posts.length).sort((a, b) => rarity(a.hit) - rarity(b.hit) || b.posts[0].date.localeCompare(a.posts[0].date));
    if (!hits.length){ list.innerHTML = `<li class="hb-empty">No hits logged in the last ${win} days. Catch the next one live.</li>`; return; }
    list.innerHTML = hits.slice(0, 4).map(h => `<li><a href="https://www.instagram.com/p/${h.posts[0].id}/" target="_blank" rel="noopener">
      <b>${esc(h.hit)}</b><span class="t"><strong>${esc(h.title)}</strong><small>${h.posts.length > 1 ? h.posts.length + ' posts' : h.posts[0].kind === 'photo' ? 'Photo' : 'Reel'}</small></span><span class="ago">${ago(h.posts[0].date)}</span></a></li>`).join('');
    const more = hits.length > 4 ? ` · +${hits.length - 4} more` : '';
    foot.textContent = `${hits.length} hit${hits.length === 1 ? '' : 's'} in ${win} days${more} · updated ${new Date(feed.updated).toLocaleDateString('en-GB', {day:'numeric', month:'short'})}`;
  }).catch(() => { list.innerHTML = '<li class="hb-empty">See our latest hits on Instagram.</li>'; });
}

/* The journey: stops sit along a winding path that runs into the screen. The camera travels to
   wherever the timeline knob is, so dragging it scrubs back and forth through clips and info. */
function bindLive(){
  const jr = $('#journey'); if (!jr) return () => {};
  const world = $('#world'), stops = [...world.querySelectorAll('.stop')], N = stops.length;
  const track = $('#track'), knob = $('#knob'), fill = $('#fill2'), bubble = $('#bubble');
  const dots = [...track.querySelectorAll('.dot')], playBtn = $('#tlPlay');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let t = 0, view = 0, dragging = false, playing = !reduce, nextAt = performance.now() + 5200, cur = -1, raf = 0, alive = true;
  let D = 560, X = 210, S = 1;
  const geo = () => { const w = jr.clientWidth; S = Math.min(1, w < 760 ? w / 500 : w / 760); D = 560; X = w < 760 ? 70 : 230; };
  const px = i => (i % 2 ? 1 : -1) * X * (i === 0 ? .2 : 1);
  const pz = i => -i * D;
  const lerp = (a, b, k) => a + (b - a) * k;
  const at = (fn, v) => { const i = Math.max(0, Math.min(N - 1, Math.floor(v))), k = v - i; return i >= N - 1 ? fn(N - 1) : lerp(fn(i), fn(i + 1), k * k * (3 - 2 * k)); };
  const FLOOR = 250;
  // dashed path along the floor between neighbouring stops
  const paths = [];
  for (let i = 0; i < N - 1; i++){
    const el = document.createElement('div'); el.className = 'path';
    world.prepend(el); paths.push(el);
    const pin = document.createElement('div'); pin.className = 'pin'; world.prepend(pin); paths.push(pin);
  }
  const lastPin = document.createElement('div'); lastPin.className = 'pin'; world.prepend(lastPin);
  const layout = () => {
    geo();
    stops.forEach((s, i) => s.style.transform = `translate3d(${px(i)}px,0,${pz(i)}px)`);
    for (let i = 0; i < N - 1; i++){
      const dx = px(i + 1) - px(i), dz = pz(i + 1) - pz(i), L = Math.hypot(dx, dz);
      const mx = (px(i) + px(i + 1)) / 2, mz = (pz(i) + pz(i + 1)) / 2, th = Math.atan2(dx, dz) * 180 / Math.PI;
      const path = paths[i * 2], pin = paths[i * 2 + 1];
      path.style.height = L + 'px'; path.style.top = (-L / 2) + 'px';
      path.style.transform = `translate3d(${mx}px,${FLOOR}px,${mz}px) rotateY(${th}deg) rotateX(90deg)`;
      pin.style.transform = `translate3d(${px(i)}px,${FLOOR}px,${pz(i)}px) rotateX(90deg)`;
    }
    lastPin.style.transform = `translate3d(${px(N - 1)}px,${FLOOR}px,${pz(N - 1)}px) rotateX(90deg)`;
  };
  layout(); addEventListener('resize', layout);

  loadHits();
  Promise.resolve(window.SR_VIDEOS || []).then(ids => {
    stops.forEach(s => { const a = s.querySelector('.clip'); if (a && ids.includes(a.dataset.id)) a.dataset.clip = '1'; });
    cur = -1;
  }).catch(() => {});
  const setCur = i => {
    if (i === cur) return;
    const old = stops[cur]?.querySelector('video'); if (old) old.pause();
    cur = i;
    const a = stops[i].querySelector('.clip');
    if (a && a.dataset.clip){ const v = a.querySelector('video'); if (!v.src){ v.src = `${A(a.dataset.id+'.mp4')}`; v.addEventListener('loadeddata', () => a.classList.add('has-video'), {once:true}); } v.play().catch(() => {}); }
    knob.setAttribute('aria-valuenow', i + 1); knob.setAttribute('aria-valuetext', STOPS[i].label);
    bubble.textContent = STOPS[i].label;
    dots.forEach((d, k) => { d.classList.toggle('past', k <= i); d.classList.toggle('cur', k === i); });
  };
  const go = i => { t = ((i % N) + N) % N; };
  const setPlaying = on => {
    playing = on; nextAt = performance.now() + 5200;
    playBtn.classList.toggle('playing', on);
    playBtn.setAttribute('aria-label', on ? 'Pause the journey' : 'Play the journey');
    playBtn.innerHTML = on ? '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>' : '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 4.5v15l13-7.5z"/></svg>';
  };
  setPlaying(playing);
  const user = () => setPlaying(false);

  const frame = now => {
    if (!alive) return;
    raf = requestAnimationFrame(frame);
    const r = jr.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;
    const dt = Math.min(.05, (now - (frame.t || now)) / 1000); frame.t = now;
    if (playing && !dragging && now > nextAt){ go(Math.round(t) + 1); nextAt = now + 5200; }
    view += (t - view) * (reduce ? 1 : 1 - Math.exp(-dt * (dragging ? 14 : 4.2)));
    if (Math.abs(t - view) < .0005) view = t;
    const cx = at(px, view), cz = at(pz, view);
    const sway = (at(px, Math.min(N - 1, view + .5)) - cx) * .03;
    world.style.transform = `scale(${S}) rotateY(${sway}deg) translate3d(${-cx}px,0,${-cz + 70}px)`;
    stops.forEach((s, i) => {
      const d = i - view;
      const op = d < -.55 ? Math.max(0, 1 + (d + .55) * 3) : d > 3.2 ? Math.max(0, 1 - (d - 3.2)) : 1;
      s.style.opacity = op.toFixed(3);
      s.style.visibility = op <= 0 ? 'hidden' : 'visible';
      s.style.filter = d > .35 ? `blur(${Math.min(6, (d - .35) * 2.2).toFixed(2)}px) brightness(${Math.max(.45, 1 - d * .18).toFixed(2)})` : 'none';
      s.style.pointerEvents = Math.abs(d) < .4 ? 'auto' : 'none';
    });
    const pct = view / (N - 1) * 100;
    knob.style.left = pct + '%'; fill.style.width = pct + '%';
    setCur(Math.round(view));
  };
  raf = requestAnimationFrame(frame);

  const fromX = x => { const r = track.getBoundingClientRect(); return Math.max(0, Math.min(N - 1, (x - r.left) / r.width * (N - 1))); };
  const down = e => { if (e.target.closest('.dot') && e.target !== knob) return; dragging = true; user(); t = fromX(e.clientX); track.setPointerCapture?.(e.pointerId); e.preventDefault(); };
  const move = e => { if (dragging) t = fromX(e.clientX); };
  const up = () => { if (!dragging) return; dragging = false; t = Math.round(t); };
  track.addEventListener('pointerdown', down); track.addEventListener('pointermove', move);
  track.addEventListener('pointerup', up); track.addEventListener('pointercancel', up);
  dots.forEach(d => d.addEventListener('click', () => { user(); go(+d.dataset.i); }));
  knob.addEventListener('keydown', e => {
    const k = {ArrowRight:1, ArrowUp:1, ArrowLeft:-1, ArrowDown:-1}[e.key];
    if (k){ e.preventDefault(); user(); t = Math.max(0, Math.min(N - 1, Math.round(t) + k)); }
    if (e.key === 'Home'){ e.preventDefault(); user(); t = 0; } if (e.key === 'End'){ e.preventDefault(); user(); t = N - 1; }
  });
  $('#tlPrev').addEventListener('click', () => { user(); t = Math.max(0, Math.round(t) - 1); });
  playBtn.addEventListener('click', () => { if (!playing && Math.round(t) >= N - 1) t = 0; setPlaying(!playing); });
  jr.addEventListener('pointerenter', () => { nextAt = Infinity; });
  jr.addEventListener('pointerleave', () => { if (playing) nextAt = performance.now() + 3000; });
  return () => { alive = false; cancelAnimationFrame(raf); removeEventListener('resize', layout); stops.forEach(s => s.querySelector('video')?.pause()); };
}

/* ---------- LIVE page ---------- */
const ICON = {
  live:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="2.5" fill="currentColor"/><path d="M7.8 7.8a6 6 0 0 0 0 8.4M16.2 7.8a6 6 0 0 1 0 8.4M5 5a10 10 0 0 0 0 14M19 5a10 10 0 0 1 0 14"/></svg>',
  box:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="M3 7.5 12 12l9-4.5M12 12v9"/></svg>',
  people:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20a6.5 6.5 0 0 1 13 0"/><circle cx="17.5" cy="9" r="2.5"/><path d="M16 14.2a5 5 0 0 1 6 4.8"/></svg>',
  home:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 11 12 4l9 7"/><path d="M5 10v10h14V10"/></svg>',
};
const LP_FEED = ['DektjQiIwUH','Dekt8g0IMvp','DedCoJ5Iy7A','DeajYLVqGXT','Denthv0I-6o'];
const BREAK_STEPS = [
  {t:'Grab a spot', d:'Every break lists its spots before we go live. Buy yours in the Whatnot app, and once the spots are filled, we start.'},
  {t:'We rip it live', d:'Every pack is opened on stream, so you watch each card come out in real time with the rest of the chat.'},
  {t:'Your hits are yours', d:'Whatever lands in your spot is yours, from base cards all the way up to the 1/1s.'},
  {t:'Shipped to you', d:'We pack your cards carefully and send them out. Our average ship time on Whatnot is 1 day.'},
];

function livePage(){
  const wn = WN_ICON.replace('<svg', '<svg');
  return `
  <div class="lp">
    <section class="lp-hero">
      <div class="wrap">
        <div class="copy2">
          <div class="lp-badge">${wn}<div><b>theshowroomuk</b><span>Live on Whatnot</span></div></div>
          <h1>The Showroom, <em>live</em></h1>
          <p class="lede">We open trading cards live on Whatnot: Star Wars Chrome cases, One Piece, Pokémon and Topps. Grab a spot, watch it get ripped on stream and keep every hit that lands in your spot.</p>
          <div class="lp-ctas">
            <a class="btn btn-y" href="${WHATNOT}" target="_blank" rel="noopener">Follow us on Whatnot ${arrowSm}</a>
            <a class="btn btn-o" href="#lp-join">How to get involved</a>
          </div>
          <div class="lp-stats">
            <div><b>${WN_STATS.rating}★</b><span>${WN_STATS.reviews} reviews</span></div>
            <div><b>${WN_STATS.sold}</b><span>items sold</span></div>
            <div><b>${WN_STATS.followers}</b><span>followers</span></div>
            <div><b>${WN_STATS.ship}</b><span>avg ship</span></div>
          </div>
        </div>
        <div class="stream" aria-hidden="true">
          <div class="orbit">${['1/1','Sketch','/5','Era'].map((b,k)=>`<b style="--k:${k}">${b}</b>`).join('')}</div>
          <div class="phone"><div class="screen" id="lpScreen">
            ${LP_FEED.map((id,i)=>`<video class="${i?'':'on'}" src="${A(id+'.mp4')}" poster="${A(id+'.jpg')}" muted playsinline preload="${i?'none':'auto'}"></video>`).join('')}
            <div class="scr-top"><span class="pill"><i></i>LIVE</span><span class="who">${wn}theshowroomuk</span></div>
            <div class="scr-bot">
              <div class="show">Star Wars Chrome x10 Hobby Break</div>
              <div class="spots" id="lpSpots">${'<i></i>'.repeat(10)}</div>
              <div class="scr-buy"><span>Grab a spot</span>${arrowSm}</div>
            </div>
          </div></div>
          <div class="react" id="lpReact"></div>
        </div>
      </div>
    </section>

    <section class="lp-sec"><div class="wrap split">
      <div>
        <div class="eyebrow">What is Whatnot?</div>
        <h2 style="margin-top:16px">Shopping, <em>but live</em></h2>
      </div>
      <div>
        <p class="body">Whatnot is a live shopping app. Sellers go live on video and you buy in real time, through auctions, buy-it-now listings and card breaks. You chat with the seller and everyone else watching while it happens.</p>
        <p class="body">Payments, orders and shipping all run through the Whatnot app, so there is nothing to set up on our side. Download it, follow us, and you are in.</p>
        <div class="pillars" style="margin-top:28px">
          <div class="pillar"><div class="ic">${ICON.live}</div><div><b>Live breaks</b><span>Buy a spot, we open the product on stream and the cards in your spot are yours.</span></div></div>
          <div class="pillar"><div class="ic">${ICON.box}</div><div><b>Sealed product and singles</b><span>Boxes, packs and graded cards listed during our shows.</span></div></div>
          <div class="pillar"><div class="ic">${ICON.people}</div><div><b>A proper community</b><span>${WN_STATS.followers} followers on Whatnot, plus our Discord between streams.</span></div></div>
        </div>
      </div>
    </div></section>

    <section class="brk" id="lpBreak" aria-label="How a break works">
      <div class="brk-stage"><div class="wrap">
        <div class="brk-steps">
          <div><div class="eyebrow">How a break works</div><h2 style="margin-top:16px">From spot <em>to slab</em></h2></div>
          ${BREAK_STEPS.map((st,i)=>`<div class="bstep${i?'':' on'}"><span class="n">${i+1}</span><div><b>${st.t}</b><span>${st.d}</span><i></i></div></div>`).join('')}
        </div>
        <div class="brk-vis" aria-hidden="true">
          <div class="layer on" data-l="0">
            <div class="lv-title">Star Wars Chrome x10 hobby break</div>
            <div class="spotgrid">${Array.from({length:10},(_,k)=>`<div class="spot">${k+1}<small>Spot</small></div>`).join('')}</div>
            <div class="spotcount" id="spotCount">0 / 10 spots</div>
          </div>
          <div class="layer" data-l="1">
            <div class="lv-title">Opening on stream</div>
            <div class="boxwrap">
              ${Array.from({length:6},()=>'<div class="pack">PACK</div>').join('')}
              <div class="hlid" id="hLid"></div>
              <div class="hbox"><div>HOBBY BOX<small>Sealed until we go live</small></div></div>
            </div>
          </div>
          <div class="layer" data-l="2">
            <div class="flip">
              <div class="burst">${Array.from({length:14},(_,k)=>`<i style="--a:${k*360/14}deg"></i>`).join('')}</div>
              <div class="flip-in" id="flipIn">
                <div class="face back">${wn}</div>
                <div class="face front"><img src="${A('ahsoka-triple-auto.jpg')}" alt=""></div>
              </div>
              <span class="hitbadge" id="hitBadge">1/1</span>
              <div class="hitcap">Triple Auto Ahsoka<span>Pulled live · Star Wars Chrome 2026</span></div>
            </div>
          </div>
          <div class="layer" data-l="3">
            <div class="route">
              <svg class="road" viewBox="0 0 520 240" preserveAspectRatio="none"><path id="road" d="M32 120 C 150 10, 250 230, 370 110 S 470 100, 488 120" fill="none" stroke="#ffe414" stroke-width="3" stroke-dasharray="10 10" stroke-linecap="round" opacity=".7"/></svg>
              <div class="origin"><img src="${A('logo.png')}" alt=""></div>
              <div class="dest">${ICON.home}</div>
              <div class="parcel" id="parcel"></div>
              <div class="shipnote"><b>${WN_STATS.ship}</b><span>average ship time on Whatnot</span></div>
            </div>
          </div>
        </div>
      </div></div>
    </section>

    <section class="lp-sec"><div class="wrap">
      <div class="eyebrow">What we break</div>
      <h2 style="margin-top:16px">On the <em>table</em></h2>
      <p class="lede" style="margin-top:16px">Our bio says it best: all things One Piece, Pokémon, TCG and more. These are the products you will see most on our streams.</p>
      <div class="formats">
        <div class="format"><span class="kind">Case and hobby breaks</span><div class="ph"><img class="logo" src="${A('star-wars.svg')}" alt="Star Wars"></div><div class="tx"><b>Star Wars Chrome</b><span>Full case breaks and x10 hobby box breaks of Topps Star Wars Chrome.</span></div></div>
        <div class="format"><span class="kind">Boxes and breaks</span><div class="ph"><img class="logo" src="${A('one-piece.webp')}" alt="One Piece"></div><div class="tx"><b>One Piece</b><span>Booster boxes from the One Piece Card Game, opened live.</span></div></div>
        <div class="format"><span class="kind">Boxes and breaks</span><div class="ph"><img class="logo" src="${A('pokemon.svg')}" alt="Pokémon"></div><div class="tx"><b>Pokémon</b><span>Scarlet &amp; Violet boxes, Elite Trainer Boxes and special sets.</span></div></div>
        <div class="format"><span class="kind">Hobby boxes</span><div class="ph"><img class="logo" src="${A('marvel.svg')}" alt="Marvel"></div><div class="tx"><b>Topps Marvel</b><span>Marvel Chrome, Marvel Mint and other Topps drops.</span></div></div>
      </div>
    </div></section>

    <section class="lp-sec" id="lp-join"><div class="wrap">
      <div class="eyebrow">Get involved</div>
      <h2 style="margin-top:16px">Five steps <em>to your first hit</em></h2>
      <div class="steps5">
        <div class="gstep y"><b>Join Whatnot through our link</b><span>Download the app and sign up through our link to get £25 free credit.</span><a href="${WHATNOT}" target="_blank" rel="noopener">Claim £25 ${arrowSm}</a></div>
        <div class="gstep"><b>Follow theshowroomuk</b><span>Follow us and turn on notifications so you know the moment a show starts.</span><a href="${WHATNOT}" target="_blank" rel="noopener">Our Whatnot ${arrowSm}</a></div>
        <div class="gstep dc"><b>Join the Discord</b><span>Hang out between streams, talk breaks and see what everyone pulled.</span><a href="${DISCORD}" target="_blank" rel="noopener">discord.gg/9eefvwtZaz ${arrowSm}</a></div>
        <div class="gstep"><b>Pick a show</b><span>Upcoming shows are listed on our Whatnot profile, with the product and spots shown before we go live.</span><a href="${WHATNOT}" target="_blank" rel="noopener">See upcoming shows ${arrowSm}</a></div>
        <div class="gstep"><b>Watch and win</b><span>Tune in, watch your spot get opened and we ship your cards straight to you.</span><a href="#lpHits">Recent hits ${arrowSm}</a></div>
      </div>
    </div></section>

    <section class="lp-sec" id="lpHits"><div class="wrap">
      <div class="block-head" style="margin-bottom:0"><div><div class="eyebrow">Pulled live · last 40 days</div><h2 style="margin-top:16px">Recent <em>hits</em></h2></div>
        <a class="btn btn-o" href="${IG}" target="_blank" rel="noopener">More on Instagram</a></div>
      <div class="hitgrid" id="lpHitGrid"><p class="hb-empty">Loading the latest hits…</p></div>
    </div></section>

    <section class="lp-sec"><div class="wrap split">
      <div><div class="eyebrow">Questions</div><h2 style="margin-top:16px">Good <em>to know</em></h2></div>
      <div>
        <details open><summary>What is a break?</summary><p>We open a sealed box or case live, and the spots in it are sold before we start. A spot might be a character, a team or a random draw, and each show says which. Every card that matches your spot is yours.</p></details>
        <details><summary>How much is a spot?</summary><p>It depends on the product and how many spots the break has. Prices are on each show in the Whatnot app before it starts.</p></details>
        <details><summary>Do I have to watch live?</summary><p>It is more fun live, but you do not have to be there. Once you buy a spot, whatever lands in it is yours.</p></details>
        <details><summary>When do I get my cards?</summary><p>We ship after the break. Our average ship time on Whatnot is ${WN_STATS.ship}.</p></details>
        <details><summary>Is it safe?</summary><p>Payment and orders go through Whatnot, and our shop is rated ${WN_STATS.rating} from ${WN_STATS.reviews} reviews with ${WN_STATS.sold} items sold.</p></details>
      </div>
    </div></section>

    <div class="wrap"><div class="final">
      <div><h2>Your spot is waiting</h2><p>New to Whatnot? Sign up through our link for £25 free credit, follow theshowroomuk and catch the next break live.</p></div>
      <div class="btns">
        <a class="btn btn-k" href="${WHATNOT}" target="_blank" rel="noopener">Follow on Whatnot ${arrowSm}</a>
        <a class="btn btn-k2" href="${DISCORD}" target="_blank" rel="noopener">Join the Discord</a>
      </div>
      ${WN_ICON.replace('<svg', '<svg class="bg"')}
    </div></div>
  </div>`;
}

function bindLivePage(){
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const timers = [], cleanups = [];
  // hero: the phone plays each pull reel in turn, spots fill, reactions float up
  const reels = [...document.querySelectorAll('#lpScreen video')], spots = [...document.querySelectorAll('#lpSpots i')];
  let reelAt = 0, filled = 0;
  const fill = n => spots.forEach((s, k) => s.classList.toggle('on', k < n));
  const playReel = i => {
    reels[reelAt].classList.remove('on'); const prev = reels[reelAt]; setTimeout(() => prev.pause(), 1000);
    reelAt = i; const v = reels[reelAt];
    v.currentTime = 0; v.classList.add('on'); v.play().catch(() => {});
    reels[(reelAt + 1) % reels.length].preload = 'auto'; // warm up the next one
  };
  reels.forEach((v, i) => v.addEventListener('ended', () => { if (i === reelAt) playReel((reelAt + 1) % reels.length); }));
  if (!reduce){
    reels[0].play().catch(() => {});
    cleanups.push(() => reels.forEach(v => v.pause()));
    timers.push(setInterval(() => { filled = filled >= 10 ? 0 : filled + 1; fill(filled); }, 650));
    const box = $('#lpReact'), em = ['🔥','💎','⚡','🙌','😱','🤯'];
    timers.push(setInterval(() => {
      const e = document.createElement('span'); e.textContent = em[Math.random() * em.length | 0];
      e.style.left = (Math.random() * 70) + 'px'; e.style.setProperty('--dx', (Math.random() * 60 - 30) + 'px');
      box.appendChild(e); setTimeout(() => e.remove(), 3300);
    }, 520));
  } else fill(7);

  // how a break works: scroll scrubs through four scenes
  const sec = $('#lpBreak'), stage = sec.querySelector('.brk-stage');
  const steps = [...sec.querySelectorAll('.bstep')], layers = [...sec.querySelectorAll('.layer')];
  const spotEls = [...sec.querySelectorAll('.spot')], packs = [...sec.querySelectorAll('.pack')];
  const lid = $('#hLid'), flip = $('#flipIn'), badge = $('#hitBadge'), burst = [...sec.querySelectorAll('.burst i')];
  const road = $('#road'), parcel = $('#parcel'), count = $('#spotCount'), len = road.getTotalLength();
  const clamp = v => Math.max(0, Math.min(1, v));
  let raf = 0, cur = -1;
  const tick = () => {
    raf = 0;
    const r = sec.getBoundingClientRect(), span = sec.offsetHeight - stage.offsetHeight;
    const p = clamp(-r.top / span), f = Math.min(3.999, p * 4), i = Math.floor(f), t = reduce ? 1 : f - i;
    if (i !== cur){ cur = i; layers.forEach((l, k) => l.classList.toggle('on', k === i)); }
    steps.forEach((s, k) => { s.classList.toggle('on', k === i); s.classList.toggle('done', k < i); s.querySelector('i').style.setProperty('--p', k < i ? 1 : k === i ? t : 0); });
    if (i === 0){ const n = Math.min(10, Math.ceil(clamp(t * 1.15) * 10)); spotEls.forEach((el, k) => el.classList.toggle('on', k < n)); count.textContent = `${n} / 10 spots`; }
    if (i === 1){
      lid.style.transform = `rotate(${-clamp(t * 2.2) * 112}deg)`;
      packs.forEach((pk, k) => { const q = clamp(t * 1.5 - .25 - k * .08), o = k - 2.5;
        pk.style.transform = `translate(${o * q * 64}px,${-q * 190}px) rotate(${o * q * 10}deg)`; pk.style.zIndex = q > .3 ? 5 : 2; });
    }
    if (i === 2){
      flip.style.transform = `rotateY(${clamp(t * 1.8) * 180}deg)`;
      const pop = clamp((t - .55) * 5);
      badge.style.setProperty('--pop', pop.toFixed(3));
      burst.forEach(b => { b.style.setProperty('--bo', (pop * (1 - clamp((t - .75) * 4))).toFixed(3)); b.style.setProperty('--r', 120 + pop * 70); });
      flip.querySelector('.front').style.setProperty('--sh', (110 - t * 140) + '%');
    }
    if (i === 3){
      const pt = road.getPointAtLength(clamp(t * 1.1) * len);
      parcel.style.left = (pt.x / 520 * 100) + '%'; parcel.style.top = (pt.y / 240 * 100) + '%';
    }
  };
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(tick); };
  addEventListener('scroll', onScroll, {passive:true}); addEventListener('resize', onScroll); tick();
  cleanups.push(() => { removeEventListener('scroll', onScroll); removeEventListener('resize', onScroll); });

  // recent hits from the same 40-day feed as the homepage board
  const grid = $('#lpHitGrid');
  (window.SR_HITS ? Promise.resolve(window.SR_HITS) : Promise.reject()).then(feed => {
    const win = feed.window_days || 40, cutoff = Date.now() - win * 864e5;
    const hits = feed.hits.map(h => ({...h, posts: h.posts.filter(p => new Date(p.date + 'T23:59:59Z') >= cutoff)}))
      .filter(h => h.posts.length).sort((a, b) => rarity(a.hit) - rarity(b.hit) || b.posts[0].date.localeCompare(a.posts[0].date)).slice(0, 4);
    grid.innerHTML = hits.length ? hits.map(h => `<a class="hitcard" href="https://www.instagram.com/p/${h.posts[0].id}/" target="_blank" rel="noopener">
      <img src="${(h.image && A(h.image)) || `${A(h.posts[0].id+'.jpg')}`}" alt="" loading="lazy"><span class="tag">${esc(h.hit)}</span>
      <div class="cap"><b>${esc(h.title)}</b><span>${esc(h.set || '')}</span></div></a>`).join('')
      : `<p class="hb-empty">No hits logged in the last ${win} days. Catch the next one live.</p>`;
  }).catch(() => { grid.innerHTML = '<p class="hb-empty">See our latest hits on Instagram.</p>'; });

  // in-page links (How to get involved, Recent hits) scroll instead of changing the route
  const lp = document.querySelector('.lp');
  const onClick = e => { const a = e.target.closest('a[href^="#lp"]'); if (!a) return; e.preventDefault(); document.getElementById(a.getAttribute('href').slice(1))?.scrollIntoView({behavior: reduce ? 'auto' : 'smooth'}); };
  lp.addEventListener('click', onClick);
  return () => { timers.forEach(clearInterval); cleanups.forEach(f => f()); if (raf) cancelAnimationFrame(raf); };
}

/* ---------- Rip a Pack ---------- */
// Cards from base to 1/1, rarest last. pts = score.
const TIERS = [
  {key:'base', label:'Base', pts:10, sub:'Base card'},
  {key:'ref', label:'Refractor', pts:25, sub:'Refractor parallel'},
  {key:'n99', label:'/99', pts:50, num:99, sub:'/99 parallel'},
  {key:'n25', label:'/25', pts:100, num:25, sub:'/25 parallel'},
  {key:'case', label:'Case hit', pts:200, sub:'Case hit · short print'},
  {key:'n10', label:'/10', pts:300, num:10, sub:'/10 parallel'},
  {key:'n5', label:'/5', pts:400, num:5, sub:'/5 parallel'},
  {key:'sketch', label:'Sketch', pts:500, sub:'Sketch card · hand drawn'},
  {key:'one', label:'1/1', pts:1000, num:1, sub:'One of one'},
];
const TIER_AT = Object.fromEntries(TIERS.map((t, i) => [t.key, i]));
// Where the needle stops decides what can come out (weights within each zone).
// The 1/1 only ever comes from the red line.
const RIP_ZONES = {
  red:   {upto:.016, odds:{one:1}},
  sweet: {upto:.085, odds:{case:40, n10:30, n5:20, sketch:10}},
  band:  {upto:.18,  odds:{ref:30, n99:40, n25:30}},
  low:   {upto:1,    odds:{base:68, ref:26, n99:6}},
};
const RIP_NAMES = ['Ahsoka Tano','Darth Maul','Grand Admiral Thrawn','Sabine Wren','The Mandalorian','Grogu','Boba Fett','Darth Vader','Luke Skywalker','Leia Organa','Han Solo','Obi-Wan Kenobi'];
const RIP_PACKS = 3;

function ripHTML(){
  return `
  <section class="rip" id="play" aria-labelledby="ripTitle">
    <div class="wrap">
      <div class="rip-copy">
        <div class="eyebrow">Play · 30 seconds</div>
        <h2 id="ripTitle">Rip a <em>pack</em></h2>
        <p>Three packs, one shot each. Where you stop the needle decides what you can pull. Land it dead on the red line and the 1/1 is yours.</p>
        <div class="rip-score">${Array.from({length:RIP_PACKS},(_,i)=>`<div class="slot" data-i="${i}"><small>Pack ${i+1}</small><b>—</b><span>Unopened</span></div>`).join('')}</div>
        <div class="rip-total"><div class="main"><b id="ripScore">0</b><span>Score</span></div><div><b id="ripBest">0</b><span>Your best</span></div></div>
      </div>
      <div class="rip-stage">
        <div class="rip-table" id="ripTable">
          <div class="rip-call" id="ripCall"></div>
          <div class="rpack" id="ripPack"><div class="body"><img src="${A('logo.png')}" alt=""><b>CHROME</b><small>The Showroom · Hobby pack</small></div><div class="crimp top"></div><div class="crimp bot"></div></div>
          <div class="rcard" id="ripCard"><div class="f"></div><div class="b"><img src="${A('logo.png')}" alt=""></div></div>
          <div class="rip-end" id="ripEnd"><div class="box">
            <div class="rank" id="ripRank"></div><div class="big" id="ripFinal">0</div><h3 id="ripBestPull"></h3>
            <p>Now try it with real cards. Join our breaks on Whatnot, with £25 free credit when you sign up through our link.</p>
            <div class="acts"><button class="btn btn-primary" id="ripAgain">Rip again</button><a class="btn btn-y" href="${WHATNOT}" target="_blank" rel="noopener">Rip it for real</a></div>
          </div></div>
        </div>
        <div class="meter-row">
          <div class="meter" aria-hidden="true"><div class="zone"></div><div class="bull"></div><div class="needle" id="ripNeedle"></div></div>
          <button class="btn btn-primary rip-btn" id="ripBtn">Rip it</button>
          <div class="rip-hint" id="ripHint">Stop the needle in the sweet spot</div>
        </div>
      </div>
    </div>
  </section>`;
}

function bindRip(){
  const sec = $('#play'); if (!sec) return () => {};
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pack = $('#ripPack'), card = $('#ripCard'), needle = $('#ripNeedle'), btn = $('#ripBtn'), hint = $('#ripHint');
  const call = $('#ripCall'), table = $('#ripTable'), end = $('#ripEnd'), slots = [...sec.querySelectorAll('.slot')];
  let best = 0; try { best = +localStorage.getItem('sr-rip-best') || 0; } catch(e){}
  $('#ripBest').textContent = best;
  let round = 0, score = 0, pulls = [], state = 'aim', pos = 0, dir = 1, raf = 0, last = 0, alive = true;
  const timers = [];
  const later = (f, ms) => timers.push(setTimeout(f, ms));
  const speed = () => 1.15 + round * .35;              // needle gets quicker each pack
  const tick = now => {
    if (!alive) return;
    raf = requestAnimationFrame(tick);
    const dt = Math.min(.05, (now - (last || now)) / 1000); last = now;
    if (state !== 'aim') return;
    pos += dir * dt * speed();
    if (pos >= 1){ pos = 1; dir = -1; } if (pos <= 0){ pos = 0; dir = 1; }
    needle.style.left = (pos * 100) + '%';
  };
  raf = requestAnimationFrame(tick);

  const zoneAt = d => d <= RIP_ZONES.red.upto ? 'red' : d < RIP_ZONES.sweet.upto ? 'sweet' : d < RIP_ZONES.band.upto ? 'band' : 'low';
  const pick = zone => {
    const odds = Object.entries(RIP_ZONES[zone].odds);
    let r = Math.random() * odds.reduce((a, [, w]) => a + w, 0);
    for (const [key, w] of odds){ r -= w; if (r <= 0) return TIER_AT[key]; }
    return TIER_AT[odds[0][0]];
  };
  const burst = (n, big) => {
    if (reduce) return;
    const cols = ['#3fd0dc','#7f8ff2','#9b72ee','#d5d8e2','#ffe414'];
    for (let i = 0; i < n; i++){
      const s = document.createElement('i'); s.className = 'spark';
      const a = Math.random() * Math.PI * 2, d = (big ? 160 : 90) + Math.random() * (big ? 160 : 80);
      s.style.setProperty('--x', Math.cos(a) * d + 'px'); s.style.setProperty('--y', Math.sin(a) * d + 'px');
      s.style.background = cols[i % cols.length];
      table.appendChild(s); later(() => s.remove(), 1100);
    }
  };
  const say = (txt, big) => { call.textContent = txt; call.className = 'rip-call on' + (big ? ' big' : ''); later(() => call.classList.remove('on'), 1500); };

  const rip = () => {
    state = 'rip'; btn.disabled = true;
    // the red line is just over one frame of needle travel wide, so it can be hit on every pack, but only just
    const d = Math.abs(pos - .5), zone = zoneAt(d);
    say({red:'Bullseye!', sweet:'Sweet spot!', band:'Good rip'}[zone] || (d < .32 ? 'Close' : 'Rough rip'), zone === 'red' || zone === 'sweet');
    const tier = pick(zone), t = TIERS[tier];
    const name = RIP_NAMES[Math.random() * RIP_NAMES.length | 0];
    const serial = t.num === 1 ? '1/1' : t.num ? `${String(1 + (Math.random() * t.num | 0)).padStart(2, '0')}/${t.num}` : t.label;
    card.className = 'rcard tier-' + t.key;
    card.querySelector('.f').innerHTML = `<div class="top"><span>Chrome</span><span class="serial">${serial}</span></div>
      <div class="art">${CHAR_ART?.[name] ? `<svg viewBox="0 0 100 100" role="img" aria-label="${name}">${CHAR_ART[name]}</svg>` : name.split(' ').map(w => w[0]).join('').slice(0, 2)}</div>
      <div class="nm">${name}<small>${t.sub}</small></div>`;
    pack.classList.add('shake');
    later(() => { pack.classList.remove('shake'); pack.classList.add('torn'); }, 360);
    later(() => { pack.classList.add('gone'); card.classList.add('up'); }, 800);
    later(() => {
      card.classList.add('flip');
      if (tier >= TIER_AT.n25){
        const big = tier >= TIER_AT.case;
        say(t.key === 'one' ? 'ONE OF ONE!' : t.key === 'case' ? 'Case hit!' : t.label + ' hit!', big);
        burst(tier >= TIER_AT.n5 ? 46 : big ? 30 : 16, tier >= TIER_AT.n5);
      }
      score += t.pts; pulls.push({tier, name, label:t.label, pts:t.pts});
      $('#ripScore').textContent = score;
      const slot = slots[round]; slot.classList.add('filled'); slot.classList.toggle('hot', tier >= TIER_AT.n25);
      slot.querySelector('b').textContent = t.label; slot.querySelector('span').textContent = `${name} · +${t.pts}`;
      round++;
      later(() => {
        if (round < RIP_PACKS){ state = 'next'; btn.disabled = false; btn.textContent = 'Next pack'; hint.textContent = `Pack ${round + 1} of ${RIP_PACKS}: the needle gets faster`; }
        else finish();
      }, 900);
    }, 1350);
  };
  const nextPack = () => {
    card.className = 'rcard';
    pack.className = 'rpack enter';
    requestAnimationFrame(() => requestAnimationFrame(() => { pack.className = 'rpack'; }));
    state = 'aim'; btn.textContent = 'Rip it'; hint.textContent = 'Stop the needle in the sweet spot';
  };
  const finish = () => {
    state = 'done';
    const top = pulls.reduce((a, b) => b.tier > a.tier ? b : a, pulls[0]);
    if (score > best){ best = score; try { localStorage.setItem('sr-rip-best', best); } catch(e){} $('#ripBest').textContent = best; }
    $('#ripFinal').textContent = score;
    $('#ripRank').textContent = (top.tier === TIER_AT.one ? '1/1 legend' : top.tier >= TIER_AT.case ? 'Hit hunter' : top.tier >= TIER_AT.n99 ? 'Parallel chaser' : 'Base grinder') + (score === best && score > 0 ? ' · new best' : '');
    $('#ripBestPull').textContent = `Best pull: ${top.label === 'Base' ? 'base' : top.label} ${top.name}`;
    later(() => end.classList.add('on'), 700);
    btn.textContent = 'Rip again'; btn.disabled = false; hint.textContent = 'Round over: three new packs are ready';
  };
  const reset = () => {
    end.classList.remove('on'); round = 0; score = 0; pulls = []; $('#ripScore').textContent = 0;
    slots.forEach((sl, i) => { sl.className = 'slot'; sl.querySelector('b').textContent = '—'; sl.querySelector('span').textContent = 'Unopened'; });
    nextPack();
  };
  btn.addEventListener('click', () => { if (state === 'aim') rip(); else if (state === 'next') nextPack(); else if (state === 'done') reset(); });
  $('#ripAgain').addEventListener('click', reset);
  return () => { alive = false; cancelAnimationFrame(raf); timers.forEach(clearTimeout); };
}


/* ---------- boot: start whichever interactive sections this page has ---------- */
const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const money = c => (c / 100).toLocaleString('en-GB', {style:'currency', currency: SR.currency || 'GBP'});

let tt;
function toast(m){ const t = $('#toast'); if (!t) return; t.textContent = m; t.classList.add('on'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2400); }

function mount(sel, html, bind){
  const el = document.querySelector(sel); if (!el) return;
  el.outerHTML = html();
  try { bind(); } catch (e) { console.error('[showroom]', sel, e); }
}

/* ---------- basket: Shopify's cart through the AJAX Cart API ---------- */
function openCart(on){
  const d = $('#drawer'), s = $('#scrim'); if (!d) return;
  d.classList.toggle('on', on); s.classList.toggle('on', on); d.setAttribute('aria-hidden', !on);
  if (on) $('#closeCart').focus();
}
async function refreshCart(open){
  const c = await fetch(ROOT + 'cart.js', {headers:{Accept:'application/json'}}).then(r => r.json());
  document.querySelectorAll('[data-cart-count]').forEach(b => { b.textContent = c.item_count; b.dataset.n = c.item_count; });
  const lines = $('#lines'); if (!lines) return;
  lines.innerHTML = c.items.length ? c.items.map((it, i) => `
    <div class="line"><a class="th" href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image)}&width=200" alt="">` : ''}</a>
      <div><b>${esc(it.product_title)}</b><small>${it.variant_title ? esc(it.variant_title) + ' · ' : ''}Qty ${it.quantity}</small><br>
      <button class="rm" data-line="${i + 1}">Remove</button></div>
      <div style="font-variant-numeric:tabular-nums">${money(it.final_line_price)}</div></div>`).join('')
    : `<p class="empty">Your basket is empty.<br><a href="${esc(SR.links.shop)}" class="link-arrow" style="margin-top:14px">Start shopping</a></p>`;
  $('#subtotal').textContent = money(c.total_price);
  const co = $('#checkout'); co.toggleAttribute('aria-disabled', !c.items.length); co.classList.toggle('is-off', !c.items.length);
  if (open) openCart(true);
}
document.addEventListener('click', e => {
  const rm = e.target.closest('#lines [data-line]');
  if (rm){
    fetch(ROOT + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({line: +rm.dataset.line, quantity: 0})})
      .then(() => refreshCart(false));
  }
  if (e.target.closest('[data-cart-open]')){ e.preventDefault(); refreshCart(true); }
  if (e.target.closest('#closeCart') || e.target.id === 'scrim') openCart(false);
});
document.addEventListener('keydown', e => { if (e.key === 'Escape') openCart(false); });
// any product form adds to the basket in place and opens the drawer
document.addEventListener('submit', e => {
  const f = e.target.closest('form[action*="/cart/add"]'); if (!f) return;
  e.preventDefault();
  const btn = f.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
  fetch(ROOT + 'cart/add.js', {method:'POST', body: new FormData(f), headers:{Accept:'application/json'}})
    .then(r => r.ok ? r.json() : r.json().then(j => Promise.reject(j)))
    .then(() => { toast('Added to basket'); return refreshCart(true); })
    .catch(err => toast((err && (err.description || err.message)) || 'Could not add that item'))
    .finally(() => { if (btn) btn.disabled = false; });
});

/* ---------- product page: format buttons, gallery, quantity ---------- */
function bindProduct(){
  const root = $('[data-product]'); if (!root) return;
  const input = root.querySelector('[data-variant-input]'), price = root.querySelector('[data-price]');
  const stock = root.querySelector('[data-stock]'), add = root.querySelector('[data-add]');
  const qv = root.querySelector('[data-qty-view]'), qi = root.querySelector('[data-qty]');
  const setAvail = ok => { if (stock){ stock.textContent = ok ? 'In stock' : 'Sold out'; stock.classList.toggle('no', !ok); }
    if (add){ add.disabled = !ok; add.textContent = ok ? 'Add to basket' : 'Sold out'; } };
  root.querySelectorAll('.opt').forEach(b => b.addEventListener('click', () => {
    root.querySelectorAll('.opt').forEach(x => x.setAttribute('aria-pressed', x === b));
    input.value = b.dataset.id; if (price) price.textContent = b.dataset.price;
    setAvail(b.dataset.available === 'true');
    const u = new URL(location.href); u.searchParams.set('variant', b.dataset.id); history.replaceState(null, '', u);
  }));
  root.querySelectorAll('.thumbs button').forEach(b => b.addEventListener('click', () => {
    const img = root.querySelector('.main-case img'); if (img){ img.src = b.dataset.img; img.removeAttribute('srcset'); }
    root.querySelectorAll('.thumbs button').forEach(x => x.setAttribute('aria-pressed', x === b));
  }));
  const setQ = n => { n = Math.max(1, Math.min(10, n)); qi.value = n; qv.textContent = n; };
  root.querySelector('[data-qty-minus]')?.addEventListener('click', () => setQ(+qi.value - 1));
  root.querySelector('[data-qty-plus]')?.addEventListener('click', () => setQ(+qi.value + 1));
}

/* ---------- collection page: sort select ---------- */
function bindCollection(){
  const s = $('[data-sort]'); if (!s) return;
  s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; });
}

/* ---------- footer wordmark: always spans the footer exactly ---------- */
function fitWordmark(){
  const w = $('#wordmark'); if (!w) return;
  w.style.fontSize = '100px';
  const cs = getComputedStyle(w.parentElement);
  const room = w.parentElement.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
  w.style.fontSize = Math.floor(100 * room / w.scrollWidth * 0.995) + 'px';
}

function start(){
  mount('[data-sr-hero]', heroHTML, bindHero);
  mount('[data-sr-whatnot]', liveHTML, bindLive);
  mount('[data-sr-live-page]', livePage, bindLivePage);
  mount('[data-sr-rip]', ripHTML, bindRip);
  bindProduct(); bindCollection();
  const menu = $('#menuBtn'), mnav = $('#mnav');
  menu?.addEventListener('click', () => { mnav.hidden = !mnav.hidden; menu.setAttribute('aria-expanded', !mnav.hidden); });
  addEventListener('scroll', () => $('#hdr')?.classList.toggle('scrolled', scrollY > 8), {passive:true});
  addEventListener('resize', fitWordmark); document.fonts?.ready.then(fitWordmark); fitWordmark();
  refreshCart(false).catch(() => {});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

})();
